import React from "react";

import "../../../styles/tutorial.scss";

function SantoAmaro() {
  return (
    <div class="container_como_jogar">
      <div>
        <h1>Saiba como jogar!</h1>
        <h2>Como Jogar</h2>

        <p>
          O Jogo do Bicho é o jogo de azar mais popular do Brasil! 
          Criado em 1892, no Rio de Janeiro, ele começou com a ideia de 
          ajudar financeiramente o Jardim Zoológico da cidade, 
          mas com o tempo ganhou tantos adeptos que virou 
          um negócio independente que se espalhou por todo o território nacional.
        </p>
        <p>
          Assim como outros jogos populares, o Jogo do Bicho ganhou muitos seguidores
          por ter uma mecânica simples e por não depender de habilidade do apostador. 
          Basta ter a sorte de possuir o bilhete premiado 
          a cada sorteio para receber seu prêmio, bem idêntico às loterias federais.
        </p>
        <p>
          O jogo do bicho se popularizou ainda mais na cultura local pois passou 
          a ser associado aos sonhos. Muitas pessoas relacionam sonhos 
          com os animais do Jogo do Bicho e fazem uma fezinha
          escolhendo um bicho de acordo com o sonho da noite anterior
        </p>
        <p>
          Apostar no Jogo do Bicho é muito simples: basta escolher uma modalidade de aposta, 
          um ou mais números, os Prêmios em que se deseja concorrer 
          e o valor que se deseja apostar. Finalmente escolha um sorteio.
        </p>
        <h2>Quando acontecem os sorteios?</h2>
        <p>
          O Paratodosonline utiliza os sorteios, conforme programação abaixo. 
          Todos os dias há chances de ganhar!
        </p>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th rowspan="2">Sorteio</th>
                <th rowspan="2">Horário Limite de aposta</th>
                <th rowspan="2">Horário de Sorteio</th>
                <th colspan="7" scope="colgroup" width="70%">
                  Dias da Semana
                </th>
              </tr>
              <tr>
                <th scope="col">Segunda</th>
                <th scope="col">Terça</th>
                <th scope="col">Quarta</th>
                <th scope="col">Quinta</th>
                <th scope="col">Sexta</th>
                <th scope="col">Sábado</th>
                <th scope="col">Domingo</th>
              </tr>
            </thead>
            <tr>
              <th scope="row" width="60px" class="left">
                10h BA
              </th>
              <td>09:50</td>
              <td>10:00</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
            <tr>
              <th scope="row" width="60px" class="left">
                12h BA
              </th>
              <td>11:50</td>
              <td>12:00</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
            <tr>
              <th scope="row" width="60px" class="left">
                15h BA
              </th>
              <td>14:50</td>
              <td>15:00</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
            <tr>
              <th scope="row" width="60px" class="left">
                19h BA
              </th>
              <td>18:50</td>
              <td>19:00</td>
              <td>X</td>
              <td>X</td>
              <td></td>
              <td>X</td>
              <td>X</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" width="60px" class="left">
                Federal
              </th>
              <td>18:50</td>
              <td>19:00</td>
              <td></td>
              <td></td>
              <td>X</td>
              <td></td>
              <td></td>
              <td>X</td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" width="60px" class="left">
                21h BA
              </th>
              <td>20:50</td>
              <td>21:00</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td></td>
            </tr>
          </table>
        </div>
        <p>
          Cada horário sorteia 5 milhares (de 0000 a 9999). Estes 5 sorteios são
          chamados de Prêmios.
        </p>
        <p>Exemplo de números sorteados em um sorteio:</p>
        <ul>
          <li>1º Prêmio: 1124</li>
          <li>2º Prêmio: 3857</li>
          <li>3º Prêmio: 0280</li>
          <li>4º Prêmio: 4577</li>
          <li>5º Prêmio: 2021</li>
        </ul>
        <h2>Modalidades de apostas</h2>
        <h3>Bicho</h3>
        <p>
          Também conhecida como "grupo" ou "aposta simples". Para participar,
          basta escolher um ou mais animais. Nesta modalidade, o jogador faz um
          palpite seco e concorre apenas ao primeiro prêmio.
        </p>
        <p>
          Para compreendermos o jogo, vamos considerar os seguintes resultados:
        </p>
        <ul>
          <li>1º prêmio: 1901</li>
          <li>2º prêmio: 3018</li>
          <li>3º prêmio: 6423</li>
          <li>4º prêmio: 8408</li>
          <li>5º prêmio: 2352</li>
        </ul>
        <p>
          Seguindo os resultados determinados anteriormente, o ganhador será
          aquele que escolheu o avestruz (1901), que representa as dezenas 01,
          02, 03 e 04.
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de um
          grupo e mais de um Prêmio do sorteio. Neste caso, para efeito de
          cálculo de premiação, o valor apostado é rateado entre a quantidade de
          números e Prêmios escolhidos. Veja o exemplo:
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 15,00</td>
            </tr>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 30,00</td>
            </tr>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 3,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho para cada grupo e prêmio acertado.</p>
        <ul>
          <li>1º Prêmio: 1124</li>
          <li>2º Prêmio: 3802</li>
          <li>3º Prêmio: 0280</li>
          <li>4º Prêmio: 4504</li>
          <li>5º Prêmio: 2008</li>
        </ul>
        <p>
          <b>Considerando os resultados acima:</b>
        </p>
        <ul>
          <li>A primeira aposta não seria premiada;</li>
          <li>A segunda aposta seria premiada em R$30,00;</li>
          <li>
            A terceira aposta seria premiada no 2º e 4º Prêmios, fazendo jus a
            R$6,00;
          </li>
        </ul>
        <h3>Dezena</h3>
        <p>
          Nesta modalidade de aposta, o apostador escolhe uma ou mais dezenas de
          00 a 99. Então, se o milhar sorteada terminar com 20 (ex: 1920, 2020),
          acertaram os jogadores que tiverem escolhido a dezena 20!
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de uma
          dezena e mais de um Prêmio do sorteio. Neste caso, para efeito de
          cálculo de premiação, o valor apostado é rateado entre a quantidade de
          números e Prêmios escolhidos.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Dezena</th>
              <td>20</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 50,00</td>
            </tr>
            <tr>
              <th scope="row">Dezena</th>
              <td>20</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 100,00</td>
            </tr>
            <tr>
              <th scope="row">Dezena</th>
              <td>20</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 10,00*</td>
            </tr>
            <tr>
              <th scope="row">Dezena</th>
              <td>20, 40</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 5,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho pra cada dezena e prêmio acertado.</p>
        <p>Para o sorteio abaixo:</p>
        <ul>
          <li>a primeira aposta não seria premiada;</li>
          <li>a segunda aposta seria premiada em $100,00;</li>
          <li>
            a terceira aposta seria premiada no 2º e 4º Prêmios, fazendo jus a
            $20,00;
          </li>
          <li>
            a quarta aposta seria premiada no 2º, 4º Prêmios (com a dezena 20) e
            5º Prêmio (com a dezena 40), fazendo jus a $15,00.
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 3024</li>
          <li>2º Prêmio: 2420</li>
          <li>3º Prêmio: 6680</li>
          <li>4º Prêmio: 8920</li>
          <li>5º Prêmio: 0140</li>
        </ul>
        <h3>Centena</h3>
        <p>
          A mecânica é bem parecida com a dezena, sendo que o apostador escolhe
          uma ou mais centenas de 000 a 999. Se o milhar sorteada terminar com
          020 (ex 1020, 2020), acertaram os jogadores que tiverem escolhido a
          centena 020!
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de uma
          centena e mais de um Prêmio do sorteio. Neste caso, para efeito de
          cálculo de premiação, o valor apostado é rateado entre a quantidade de
          números e Prêmios escolhidos.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Centena</th>
              <td>420</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 500,00</td>
            </tr>
            <tr>
              <th scope="row">Centena</th>
              <td>420</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 1000,00</td>
            </tr>
            <tr>
              <th scope="row">Centena</th>
              <td>420</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 100,00*</td>
            </tr>
            <tr>
              <th scope="row">Centena</th>
              <td>920, 940</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 50,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho para cada Centena e prêmio acertado.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>a primeira aposta não seria premiada;</li>
          <li>a segunda aposta seria premiada em $1.000,00;</li>
          <li>
            a terceira aposta seria premiada no 2º Prêmio, fazendo jus a
            $100,00;
          </li>
          <li>
            a quarta aposta seria premiada no 2º (com a centena 420) e 4º
            Prêmios (com centena 920), fazendo jus a $100,00.
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 3024</li>
          <li>2º Prêmio: 2420</li>
          <li>3º Prêmio: 6680</li>
          <li>4º Prêmio: 8920</li>
          <li>5º Prêmio: 0140</li>
        </ul>
        <h3>Milhar</h3>
        <p>
          A milhar é uma das modalidades preferidas dentre os apostadores. Para
          ganhar é necessário acertar o exato milhar sorteado! Se o milhar
          sorteado for 1523, acertaram os jogadores que tiverem escolhido o
          milhar 1523!
        </p>
        <p>
          Muitos apostadores apostam em milhares relacionados a fatos do dia a
          dia que chamem sua atenção, como os últimos 4 dígitos do número de um
          telefone, ou a placa de um carro!
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de um
          milhar e mais de um Prêmio do sorteio. Neste caso, para efeito de
          cálculo de premiação, o valor apostado é rateado entre a quantidade de
          números e Prêmios escolhidos.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Milhar</th>
              <td>3420</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 5000,00</td>
            </tr>
            <tr>
              <th scope="row">Milhar</th>
              <td>2420</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 10.000,00</td>
            </tr>
            <tr>
              <th scope="row">Milhar</th>
              <td>2420</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 1.000,00*</td>
            </tr>
            <tr>
              <th scope="row">Milhar</th>
              <td>8920, 1420</td>
              <td>1° ao 51º</td>
              <td>R$ 1,00</td>
              <td>R$ 500,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho para cada milhar e prêmio acertado.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>A primeira aposta não seria premiada;</li>
          <li>A segunda aposta seria premiada em R$10.000,00;</li>
          <li>
            A terceira aposta seria premiada no 2º Prêmio, fazendo jus a
            R$1.000,00;
          </li>
          <li>
            A quarta aposta seria premiada no 5º (com a centena 8920), fazendo
            jus a R$500,00.
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 3024</li>
          <li>2º Prêmio: 2420</li>
          <li>3º Prêmio: 6680</li>
          <li>4º Prêmio: 8920</li>
          <li>5º Prêmio: 0140</li>
        </ul>
        <h3>Duque de grupos</h3>
        <p>
          No duque de grupos, o apostador escolhe dois grupos (bichos) e torce
          para que ambos estejam dentre os cinco milhares sorteados.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Duque de grupos</th>
              <td>
                01 e 06
                <br />
                (avestruz e cabra)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 15,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de grupos</th>
              <td>
                06 e 24
                <br />
                (cabra e veado)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 30,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de grupos</th>
              <td>
                08 e 15
                <br />
                (camelo e jacaré)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 30,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>
            A primeira aposta acertaria 2 Prêmios (1º com o grupo 01 e 2º com o
            grupo 06) e seria premiada em $15,00;
          </li>
          <li>
            A segunda aposta acertaria 1 Prêmio (2º com o grupo 06) e não seria
            premiada;
          </li>
          <li>
            A terceira aposta acertaria 2 Prêmios (3º com o grupo 08 e 4º com o
            grupo 15) e seria premiada em $30,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2301</li>
          <li>2º Prêmio: 1024</li>
          <li>3º Prêmio: 7431</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9877</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 2 grupos
          dentre os 5 milhares sorteados.
        </p>
        <h3>Terno de Grupos</h3>
        <p>
          O Terno de Grupos tem mecânica similar ao Duque de Grupos, sendo que o
          apostador escolhe três animais (grupos) ao invés de dois. O apostador
          é premiado caso todos os três grupos escolhidos estejam dentre os
          cinco milhares sorteados.
        </p>
        <p>
          <b>Exemplos de premiação:</b>
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Terno de grupos</th>
              <td>
                01, 18 e 25
                <br />
                (avestruz, porco e cabra)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 130,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de grupos</th>
              <td>
                04, 08 e 24
                <br />
                (borboleta, camelo e veado)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 260,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de grupos</th>
              <td>
                08, 15 e 18
                <br />
                (camelo, jacaré e porco)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 260,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>Para o sorteio abaixo:</p>
        <ul>
          <li>
            a primeira aposta acertaria 2 Prêmios (1º com o grupo 01 e 5º com o
            grupo 18) e não seria premiada;
          </li>
          <li>
            a segunda aposta acertaria 1 Prêmio (2º com o grupo 08) e não seria
            premiada;
          </li>
          <li>
            a terceira aposta acertaria 3 Prêmios (2º com o grupo 08 e 4º com o
            grupo 15 e 5º com o grupo 18) e seria premiada em $260,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2301</li>
          <li>2º Prêmio: 1032</li>
          <li>3º Prêmio: 7497</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9872</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 3 grupos
          dentre os 5 milhares sorteados.
        </p>
        <h3>Duque de Dezenas</h3>
        <p>
          No duque de dezenas, o apostador escolhe duas dezenas e torce para que
          ambas estejam dentre os cinco milhares sorteados.
        </p>
        <p>
          <b>Exemplos de premiação:</b>
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Duque de dezenas</th>
              <td>24 e 72</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 200,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de dezenas</th>
              <td>42 e 57</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 400,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de dezenas</th>
              <td>31 e 57</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 400,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>
          <b>Considerando os resultados acima:</b>
        </p>
        <ul>
          <li>
            A primeira aposta acertaria 2 Prêmios (2º com a dezena 24 e 5º com a
            dezena 72) e seria premiada em R$200,00;
          </li>
          <li>
            A segunda aposta acertaria 1 Prêmio (4º com a dezena 57) e não seria
            premiada;
          </li>
          <li>
            A terceira aposta acertaria 2 Prêmios (1º com a dezena 31 e 4º com a
            dezena 57) e seria premiada em R$400,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2300</li>
          <li>2º Prêmio: 1024</li>
          <li>3º Prêmio: 7431</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9872</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 2 dezenas
          dentre os 5 milhares sorteados.
        </p>
        <h3>Terno de Dezenas</h3>
        <p>
          O Terno de Dezenas tem mecânica similar ao Duque de Dezenas, sendo que
          o apostador escolhe três dezenas ao invés de duas. O apostador é
          premiado caso todas as três dezenas escolhidas estejam dentre os cinco
          milhares sorteados.
        </p>
        <p>
          <b>Exemplos de premiação:</b>
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Terno de dezenas</th>
              <td>24, 72 e 87</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 3.000,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de dezenas</th>
              <td>42, 57 e 78</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 6.000,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de dezenas</th>
              <td>31, 57 e 72</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 6.000,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>
            A primeira aposta acertaria 2 Prêmios (2º com a dezena 24 e 5º com a
            dezena 72) e não seria premiada;
          </li>
          <li>
            A segunda aposta acertaria 1 Prêmio (4º com a dezena 57) e não seria
            premiada;
          </li>
          <li>
            A terceira aposta acertaria 3 Prêmios (3º com a dezena 31 e 4º com a
            dezena 57 e 5º com a dezena 72) e seria premiada em $6.000,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2300</li>
          <li>2º Prêmio: 1024</li>
          <li>3º Prêmio: 7431</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9872</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 3 dezenas
          dentre os 5 milhares sorteados.
        </p>
      </div>
    </div>
  );
}

export default SantoAmaro;



// WEBPACK FOOTER //
// ./src/static/tutorial/loteria-popular/santoamaro.jsx